import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";
import { COLOR_AZUL_MAIN, COLOR_VERDE_MAIN } from "../../utils/const/colors-const";

const FORM_BG = "#e8f1f8";
const FORM_BORDER = "#dadce0";
const FORM_TEXT = "#0F3457";
const FORM_TEXT_MUTED = "#5f6368";

export default function EnviadoPage() {
    const { t } = useTranslation();

    //   const handleCerrarPestana = () => {
    //     window.close();
    //   };

    return (
        <div
            className="min-h-screen px-3 py-4 sm:px-4 sm:py-6 md:px-6 flex items-center justify-center"
            style={{ backgroundColor: FORM_BG }}
        >
            <div className="mx-auto w-full max-w-[640px]">
                <div
                    className="overflow-hidden rounded-lg border bg-white shadow-sm"
                    style={{ borderColor: FORM_BORDER }}
                >
                    <div className="h-2.5" style={{ backgroundColor: COLOR_AZUL_MAIN }} />
                    <div className="px-6 py-10 sm:px-10 sm:py-12 text-center">
                        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-green-50">
                            <CheckCircle2 className="h-10 w-10" style={{ color: COLOR_VERDE_MAIN }} />
                        </div>
                        <h1
                            className="text-[22px] sm:text-[28px] font-normal leading-tight mb-3"
                            style={{ color: FORM_TEXT }}
                        >
                            {t("label_peticion_enviada_titulo")}
                        </h1>
                        <p className="text-sm sm:text-base leading-relaxed mb-2" style={{ color: FORM_TEXT_MUTED }}>
                            {t("label_peticion_enviada_mensaje")}
                        </p>
                        <p className="text-sm sm:text-base leading-relaxed mb-8" style={{ color: FORM_TEXT_MUTED }}>
                            {t("label_puede_cerrar_pestana")}
                        </p>
                        {/* <button
              type="button"
              onClick={handleCerrarPestana}
              className="inline-flex justify-center px-6 py-2.5 text-sm font-medium text-white rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
              style={{ backgroundColor: COLOR_AZUL_MAIN }}
            >
              {t("label_cerrar_pestana")}
            </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
